/**
 * 客户管理
 */

export default [
  {
    path: 'cus/manage',
    name: '企业管理',
    component: () => import (`@/views/cus/index.vue`),
  },
  {
    path: 'cus/info',
    name: '企业信息',
    component: () => import (`@/views/cus/info.vue`),
  },
  {
    path: 'cus/order',
    name: '企业订单',
    component: () => import (`@/views/cus/order/index.vue`),
  },
  {
    path: 'cus/emp',
    name: '企业员工',
    component: () => import (`@/views/cus/emp/index.vue`),
  },
];

